import React from 'react';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Container from '@zg-rentals/multibrand-ui/lib/Container';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import cx from 'classnames';
import './style.scss';

type Props = {
  title: string;
  onEdit: () => void;
  showEdit: boolean;
  editingDisabled: boolean;
  className: string;
  buttonTitle: string;
};

class DetailsCard extends React.Component<React.PropsWithChildren<Props>> {
  static defaultProps = {
    title: '',
    onEdit: () => {},
    showEdit: true,
    editingDisabled: false,
    className: '',
    buttonTitle: 'Edit',
  };

  gotoEditPage = (e): void => {
    const { onEdit } = this.props;
    e.preventDefault();
    onEdit();
  };

  render(): React.ReactNode {
    const { editingDisabled, children, showEdit, className, buttonTitle } = this.props;
    const contents = React.Children.map(
      children,
      (child, index) =>
        child && (
          <Text key={index.toString()} className="fs-exclude">
            {child}
          </Text>
        ),
    );

    return (
      <Container className={cx('Payments-DetailsCard', className)}>
        <Row noPadding>
          <Col xs={7} sm={8} className="pan">
            <Text type="h4" className="Payments-DetailsCard-title">
              {this.props.title}
            </Text>
            {contents}
          </Col>
          <Col xs={5} sm={4}>
            {showEdit && (
              <Button type="tertiary" size="sm" full onClick={this.gotoEditPage} disabled={editingDisabled}>
                {buttonTitle}
              </Button>
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

export default DetailsCard;
